import { render, staticRenderFns } from "./require-search-result.vue?vue&type=template&id=57020316&scoped=true&"
import script from "./require-search-result.vue?vue&type=script&lang=js&"
export * from "./require-search-result.vue?vue&type=script&lang=js&"
import style0 from "./require-search-result.vue?vue&type=style&index=0&id=57020316&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57020316",
  null
  
)

export default component.exports